import moment from 'moment';

export const formatDate = dateTime => 
  moment(dateTime).format('Do MMMM YYYY');

export default formatDate;
